import type { PortalSiteBillingContactDto } from '@supply-mover-2-0/shared';

/**
 * Build a `tel:` href from a display phone string (PD-14363). The admin
 * types the number as it should READ (e.g. "1-800-555-0100"); the href
 * needs only the dialable characters, so strip everything except digits
 * and a leading `+`.
 */
export function telHref(displayPhone: string): string {
	return `tel:${displayPhone.replace(/[^+\d]/g, '')}`;
}

/**
 * PD-17321 — the contact the public payment-link, payment-method-link and
 * sent-form pages show. Each half falls back on its own: the billing phone,
 * else the support phone, and the billing email, else the support email. A
 * brand that only sets a billing email (Pharmsource's accounting address)
 * keeps showing its support phone. Null when neither has a phone or an email,
 * so the page leaves the line out.
 */
export function paymentPageContact(
	billing: PortalSiteBillingContactDto | null | undefined,
	support: PortalSiteBillingContactDto | null | undefined,
): PortalSiteBillingContactDto | null {
	const contact = {
		phone: billing?.phone ?? support?.phone ?? null,
		email: billing?.email ?? support?.email ?? null,
	};
	return hasContactLine(contact) ? contact : null;
}

function hasContactLine(
	contact: PortalSiteBillingContactDto | null | undefined,
): contact is PortalSiteBillingContactDto {
	return contact != null && (contact.phone != null || contact.email != null);
}
